import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  useMyProperties,
  useMyPropertiesCount,
} from "@/_actions/propertiesActions";
import PropertyTable from "../properties/PropertyTable";
import Pagination from "@/components/navigation/Pagination";

import { propertiesParamsAtom } from "@/_actions/propertiesActions";
import { useAtom } from "jotai";
import usePlanStore from "@/stores/planStore";

import Filters from "./filters";

export default function Properties() {
  const [params, setParams] = useAtom(propertiesParamsAtom);
  const [publishedPropertiesCount, setPublishedPropertiesCount] = useState(0);
  const [onlyRentProperties, setOnlyRentProperties] = useState(0);
  const {
    data: myProperties,
    mutate: mutateMyProperties,
    isLoading: isLoading,
  } = useMyProperties(params);
  const { data: allPropertiesCount, mutate: mutateAllProperties } =
    useMyPropertiesCount();

  const { canPublish } = usePlanStore((state) => state);

  useEffect(() => {
    setPublishedPropertiesCount(allPropertiesCount?.properties_in_plan);
    setOnlyRentProperties(allPropertiesCount?.rent_properties);
  }, [myProperties, allPropertiesCount]);
  const r = myProperties?.results || [];

  const navigate = useNavigate();

  return (
    <div className="space-y-2 divider-y sm:p-2 lg:p-4">
      <div className="flex items-center justify-between flex-1">
        <button
          onClick={() => navigate("/properties/create")}
          className="button-primary "
        >
          {publishedPropertiesCount ===
          allPropertiesCount?.limit_properties_plan
            ? "Crear propiedad en renta"
            : "Crear propiedad"}
        </button>
      </div>
      <div className="bg-white p-4 rounded-2xl">
        <Filters />
      </div>
      <div className="bg-white p-4 rounded-2xl">
        <PropertyTable
          properties={r}
          mutateData={() => {
            mutateMyProperties();
            mutateAllProperties();
          }}
          publishedProperties={publishedPropertiesCount}
          rentProperties={onlyRentProperties}
          canPublish={canPublish}
          isLoading={isLoading}
        />
      </div>

      <Pagination
        total={myProperties?.count}
        type={"Propiedad"}
        current={params.page}
        next={myProperties?.next}
        previous={myProperties?.previous}
        pageSize={10}
        onPageChange={(page) => setParams((prev) => ({ ...prev, page }))}
      />
    </div>
  );
}
